import React, { Component } from 'react';
import './Burger.css';

class Burger extends Component {

    render() {
    return (
        <div id="humberger">
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
    }
}

export default Burger;
